@use "@fukuri-admins/ui/layout" as *;

.table {
  border: 1px solid border('Tertiary');
  border-radius: borderRadius('lg');
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;

  // 最終行の td は外枠の下辺 border と重なるため border-bottom を消す
  tbody tr:last-child td {
    border-bottom: none;
  }
}

// scrollable=true 時に横スクロールを有効化する
// .table の overflow: hidden を .table.scrollable で上書き（複合セレクタで specificity を上げて確実に上書き）
// display: block に切り替えて flex による align-items: stretch の影響を回避し、内部 <table> がコンテナ幅を超えてオーバーフローできるようにする
.table.scrollable {
  overflow-x: auto;
  overflow-y: hidden;
  display: block;

  // display: block により内部 <table> がコンテンツ幅まで縮むのを防ぐため、親幅まで広げる
  // 親より広い場合は <table> 本来の挙動でオーバーフローし、横スクロールが発生する
  > table {
    min-width: 100%;
  }
}

// fixedHeader=true 時に縦スクロールとヘッダー固定を有効化する
// scrollable と組み合わせると overflow-y: hidden を auto で上書きし、縦横両方スクロール可能になる
.table.fixedHeader {
  overflow-y: auto;
  display: block;

  > table {
    min-width: 100%;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 1;
  }
}

// fillHeight=true 時、テーブル自身の高さをビューポートの残り高さに合わせて可変にする
// ヘッダー固定・内部スクロールは .fixedHeader を流用する（Table コンポーネント側で同時に付与）ため、
// このブロックは max-height の指定のみ担う。max-height は上限であって height ではないため、
// 行数が少ない場合はコンテンツの高さに収まり、空白（dead space）は生まれない
// size プリセットごとにオフセット値（ページヘッダー・ページャー等の概算クロム量、px）を固定する
// max() で 200px を下限に固定し、オフセットがビューポートを上回ってもテーブルが 0 近くまで潰れないようにする
.sizeSm {
  max-height: max(calc(100dvh - 120px), 200px); // sm: 120px
}

.sizeMd {
  max-height: max(calc(100dvh - 240px), 200px); // md（デフォルト）: 240px
}

.sizeLg {
  max-height: max(calc(100dvh - 360px), 200px); // lg: 360px
}

.sizeXl {
  max-height: max(calc(100dvh - 480px), 200px); // xl: 480px
}

.tableFixed {
  table-layout: fixed;
  width: 100%;
}

.headRow {
  th {
    @include typography('Jp/14_W3');
    color: text('Low');
    background-color: background('Senary');
  }
}
